import React from 'react'

import textLogo from 'src/assets/images/text_logo.webp'
import './HeaderStyle.scss'
import { REDIRECT_PATH, redirect } from 'src/helpers'
import { shouldShowSectionHeader } from 'src/helpers'

export const Header = () => {
  const redirectToHome = () => {
    redirect(REDIRECT_PATH.HOME)
  }

  return (
    <>
      {shouldShowSectionHeader() && (
        <>
          <div className="nav">
            <div className="section-header">
              <img className="text-logo" src={textLogo} alt="text logo" onClick={redirectToHome} />
            </div>
          </div>
        </>
      )}
    </>
  )
}
